import { render, staticRenderFns } from "./employee-skill-map-table.component.vue?vue&type=template&id=01fe4988&scoped=true&"
import script from "./employee-skill-map-table.component.vue?vue&type=script&lang=ts&"
export * from "./employee-skill-map-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./employee-skill-map-table.component.vue?vue&type=style&index=0&id=01fe4988&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe4988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
